<template>

  <v-row justify="center">

    <dialog-browser-support title="Browser Support" :showDialog.sync="showDialog" btn-cancel="" btn-ok-icon="">
        <div>Your Browser does not support Video Recording. Open this website in another browser (e.g. Chrome, Firefox, Opera) or on your Smartphone (scan QR-Code).</div>
        <v-img src="@/assets/qr-code.png"></v-img>
    </dialog-browser-support>

<!--    <v-dialog v-model="showDialog" max-width="400" >-->
<!--      <v-card>-->
<!--        <v-card-title>Browser Support</v-card-title>-->
<!--        <v-card-text>-->
<!--          <div>Your Browser does not support Video Recording. Open this website in another browser (e.g. Chrome, Firefox, Opera) or on your Smartphone (scan QR-Code).</div>-->
<!--         <v-img src="@/assets/qr-code.png"></v-img>-->
<!--        </v-card-text>-->
<!--        <v-card-actions>-->
<!--          <v-spacer></v-spacer>-->
<!--          <v-btn  text @click="showDialog=false">-->
<!--            OK-->
<!--          </v-btn>-->
<!--        </v-card-actions>-->
<!--      </v-card>-->
<!--    </v-dialog>-->

    <v-col cols="12" md="10" xl="6">
      <v-stepper
          v-model="e1"
          dark
          style="background: transparent; box-shadow: none;"
          @change="onStepChanged"
      >
        <v-stepper-header v-show="showStepperHeader">
          <v-stepper-step
              :complete="e1 > 1"
              step="1"
              :editable="editableSteps"
          >
            Hallo
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
              :complete="e1 > 2"
              step="2"
              :editable="editableSteps"
          >
            Register
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
              :complete="e1 > 3"
              step="3"
              :editable="editableSteps"
          >
            Choose Question
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
              :complete="e1 > 4"
              step="4"
              :editable="editableSteps"
          >
            Record Video
          </v-stepper-step>

          <v-divider></v-divider>
          <!--        <v-stepper-step-->
          <!--            :complete="e1 > 5"-->
          <!--            step="5"-->
          <!--            :editable="editableSteps"-->
          <!--        >-->
          <!--          Upload-->
          <!--        </v-stepper-step>-->
          <!--        <v-divider></v-divider>-->
          <v-stepper-step step="5"  :editable="editableSteps">
            Thankyou
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <step-intro />
            <v-row justify="center">
              <v-btn x-large rounded class="ma-2 my-10 btnStart" @click="gotoNextStep()">Start</v-btn>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <step-register  @cancel="onCancel" @finished="gotoNextStep()" />
          </v-stepper-content>

          <v-stepper-content step="3">
            <step-question  @cancel="onCancel" @finished="gotoNextStep()" />
          </v-stepper-content>

          <v-stepper-content step="4">
            <step-video @cancel="onCancel" @finished="gotoNextStep()"/>
                      <v-row justify="center">
                        <v-btn x-large outlined rounded color="primary" class="ma-2" @click="gotoPreviousStep()">Change Question</v-btn>
                      </v-row>
          </v-stepper-content>

          <!--        <v-stepper-content step="5">-->
          <!--          <step-upload />-->
          <!--          <v-btn color="primary" @click="gotoNextStep">Continue</v-btn>-->
          <!--          <v-btn text @click="onCancel">Cancel</v-btn>-->
          <!--        </v-stepper-content>-->

          <v-stepper-content step="5">
            <step-thankyou />
<!--            <v-row justify="center">-->
<!--              <v-btn x-large outlined rounded color="#000000" class="ma-2 my-10" @click="onCancel">Restart</v-btn>-->
<!--            </v-row>-->
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>

    </v-col>
  </v-row>


</template>

<script>


import StepVideo from "./StepVideo";
import StepRegister from "./StepRegister";
import StepIntro from "./StepIntro";
import StepQuestion from "./StepQuestion";
import StepThankyou from "./StepThankyou";
import {mapState} from 'vuex';
import DialogBrowserSupport from "../components/DialogBrowserSupport";

export default {
  name: 'home',
  components: {
    DialogBrowserSupport,
    // StepUpload,
    StepThankyou,
    StepQuestion,
    StepIntro,
    StepRegister,
    StepVideo,
  },
  data: () => ({
    e1: 1,
    showStepperHeader: false,
    editableSteps: true,
    showDialog: false,
    qrCodeUrl: "http://codegenerator.limemotion.com/?text=https://greet.ringforpeace.org&code=QRCODE&modulesize=4&margin=4",
  }),
  computed: {
    ...mapState({
      browserVideoRecordingSupport: state => state.browserVideoRecordingSupport,
      isMobile: state => state.isMobile,
    }),
  },
  mounted() {
    // if(!this.browserVideoRecordingSupport) {
    //   this.showDialog = true;
    // }
  },
  methods: {
    gotoFirstStep() {
      this.e1 = 1;
      this.scrollTotop();
    },
    gotoNextStep() {

      if(this.e1 == 1 && !this.browserVideoRecordingSupport && !this.isMobile) {
        this.showDialog = true;
      }

      this.e1 += 1;
      this.scrollTotop();
    },
    gotoPreviousStep() {
      this.e1 -= 1;
      this.scrollTotop();
    },

    onCancel() {
      this.$store.dispatch('clearAll');
      this.e1 = 1;
      this.scrollTotop();
    },
    onStepChanged(step) {
      this.e1 = parseInt(step);
      this.scrollTotop();
    },
    scrollTotop() {
      this.$nextTick(() => {
        this.$vuetify.goTo(0);
      });
    }
  }
}
</script>

<style>
.btnStart,
.btnContinue,
.btnRecord {
  background-color: #AFE7FD !important;
  color: #3F296C !important;
}

.btnPlayVideo {
  background-color: #F8B334 !important;
  color: #FFFFFF !important;
}

.btnSaveAndUpload {
  background-color: #09B11C !important;
  color: #FFFFFF !important;
}
</style>
